import HomeBlogComponent from "./HomeBlogComponent";

export default HomeBlogComponent;
